import { constants } from '../constants';

const { mobileCharacterLimit, desktopCharacterLimit, ellipsis } = constants;

export const getDescription = (
  description: string,
  isMobile: boolean
): string => {
  const charLimit = isMobile ? mobileCharacterLimit : desktopCharacterLimit;
  return description.length > charLimit
    ? description.substring(0, charLimit) + ellipsis
    : description.substring(0, charLimit);
};
